import React, { useState } from "react";
import { ref, push } from "firebase/database";
import { db } from "./firebase";
import "./BookAppointment.css";

// Calendar
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

export default function BookAppointment() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    notes: "",
  });

  const [dateValue, setDateValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const validate = () => {
    if (!formData.name.trim()) return "Please enter your name.";
    if (!formData.email.trim()) return "Please enter your email.";
    if (!formData.phone.trim()) return "Please enter your phone number.";
    if (!formData.date) return "Please select a preferred date.";
    if (!formData.time) return "Please select a preferred time.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const vErr = validate();
    if (vErr) {
      setError(vErr);
      return;
    }

    setLoading(true);

    try {
      const appointmentRef = ref(db, "appointments");
      await push(appointmentRef, {
        ...formData,
        createdAt: new Date().toISOString(),
      });

      setSuccess("🎉 Appointment requested. We’ll contact you shortly.");

      setFormData({
        name: "",
        email: "",
        phone: "",
        date: "",
        time: "",
        notes: "",
      });

      setDateValue(null);

      setTimeout(() => setSuccess(""), 3500);
    } catch (err) {
      console.error("Firebase push error:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="appointment-section">

      {/* LEFT SIDE CONTENT */}
      <div className="appointment-left">
        <h3 className="eyebrow">Book an Appointment</h3>
        <h2 className="appointment-title">
          Secure your consultation — <br />expert care, designed for you
        </h2>

        <p className="appointment-lead">
          Choose a convenient time and tell us a little about your needs. Our team will confirm your appointment and next steps.
        </p>

        <blockquote className="testimonial">
          <p className="testimonial-text">
            “Dr. Parismita and her team made the whole implant process straightforward and comfortable. My new teeth feel natural and stable — I couldn’t be happier.”
          </p>
          <footer className="testimonial-author">— Rina M., Guwahati</footer>
        </blockquote>

        <div className="trusted">
          <small>Trusted by patients across Guwahati</small>
        </div>
      </div>

      {/* RIGHT SIDE FORM */}
      <div className="appointment-right">
        <form className="appointment-form" onSubmit={handleSubmit} noValidate>

          <label>
            Full name
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your full name"
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              required
            />
          </label>

          <label>
            Phone
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91 9XXXXXXXXX"
              required
            />
          </label>

          {/* DATE + TIME */}
          <div className="row-two">

            {/* DATE PICKER */}
            <label>
              Preferred date
              <DatePicker
                selected={dateValue}
                onChange={(date) => {
                  setDateValue(date);
                  setFormData((prev) => ({
                    ...prev,
                    date: format(date, "yyyy-MM-dd"),
                  }));
                }}
                placeholderText="Select a date"
                className="date-picker"
                minDate={new Date()}
                dateFormat="dd MMM yyyy"
                required
              />
            </label>

            {/* TIME PICKER */}
            <label>
              Preferred time
              <select
                name="time"
                value={formData.time}
                onChange={handleChange}
                className="time-picker"
                required
              >
                <option value="">Select a time</option>
                <option>10:00 AM</option>
                <option>10:30 AM</option>
                <option>11:00 AM</option>
                <option>11:30 AM</option>
                <option>12:00 PM</option>
                <option>12:30 PM</option>
                <option>1:00 PM</option>
                <option>1:30 PM</option>
                <option>2:00 PM</option>
                <option>2:30 PM</option>
                <option>3:00 PM</option>
                <option>3:30 PM</option>
                <option>4:00 PM</option>
                <option>4:30 PM</option>
                <option>5:00 PM</option>
                <option>5:30 PM</option>
                <option>6:00 PM</option>
                <option>6:30 PM</option>
                <option>7:00 PM</option>
              </select>
            </label>
          </div>

          <label>
            Notes (optional)
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Tell us anything we should know..."
              rows="3"
            />
          </label>

          {error && <div className="form-error">{error}</div>}
          {success && <div className="form-success">{success}</div>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Saving..." : "Request Appointment"}
          </button>

          <p className="privacy-note">
            We’ll never share your information. By submitting, you agree to be contacted regarding this appointment.
          </p>

        </form>
      </div>

    </section>
  );
}
